import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';

export default function DateVenuePhoto({ plan, partnerId, token }) {
  const venue = plan?.venue;
  const [url, setUrl] = useState(venue?.image_url || '');
  useEffect(() => {
    let active = true;
    setUrl(venue?.image_url || '');
    if (venue?.photo_name && partnerId) {
      axios.post(`${API_BASE_URL}/date_venue_photo`, { partner_id: partnerId, choice: plan.photo_choice },
        { headers: { Authorization: `Bearer ${token || localStorage.getItem('token')}` } })
        .then(({data}) => { if (active) setUrl(data.url); }).catch(() => {});
    }
    return () => { active = false; };
  }, [venue, partnerId, token, plan?.photo_choice]);
  if (!url || !venue) return null;
  return <figure style={{margin:'0 0 12px', width:'100%'}}>
    <img src={url} alt={venue.name || plan.location} referrerPolicy="no-referrer"
      onError={() => setUrl('')} style={{width:'100%',height:160,objectFit:'cover',borderRadius:16,display:'block'}} />
    <figcaption className="venue-photo-credit">
      {venue.image_credit}
      {venue.photo_attributions?.map((author,index) => author.url
        ? <a key={index} href={author.url} target="_blank" rel="noopener noreferrer">{author.name}</a>
        : <span key={index}>{author.name}</span>)}
      {venue.photo_source_url && <a href={venue.photo_source_url} target="_blank" rel="noopener noreferrer">מקור התמונה</a>}
      {venue.image_license_url && <a href={venue.image_license_url} target="_blank" rel="noopener noreferrer">{venue.image_license}</a>}
    </figcaption>
  </figure>;
}
